import { IOrganization, IRole, IUserSettingsDataSource } from '../../../types';
import styles from './index.module.scss';
import { AuthorizedIcon } from '../../../components';
import TrashSolidBlack from '../../../assets/icons/trash-solid-b-black.svg';
import PenToSquareSolidBlack from '../../../assets/icons/pen-to-square-solid-w-black.svg';
import { Flex, Popconfirm, Tooltip } from 'antd';
import { ColumnType } from 'antd/es/table';
import { formatISOString } from '../../../utils/functions';
import { actionTypes } from '../../../assets/enums';

export const getColumns = (
  handleClickDelete: (id: number) => Promise<void>,
  handleOpenEditModal: (id: number) => Promise<void>,
  organizations: IOrganization[],
  roles: IRole[],
): Array<ColumnType<IUserSettingsDataSource> & { searchable?: boolean }> => [
  {
    title: 'Şirket',
    dataIndex: 'organization',
    key: 'organization',
    searchable: true,
    width: 150,
    filters: organizations.map((item) => ({
      text: item.name || '',
      value: item.id,
    })),
    sorter: (a, b) => a.organization - b.organization,
    render: (_, record) => (
      <Tooltip
        title={
          organizations.find((item) => item.id === record.organization)?.name
        }
      >
        <span>{`${organizations.find((item) => item.id === record.organization)?.name.slice(0, 15)}...`}</span>
      </Tooltip>
    ),
  },
  {
    title: 'İsim',
    dataIndex: 'first_name',
    key: 'first_name',
    width: 150,
    sorter: (a, b) => a.first_name?.localeCompare(b.first_name),
  },
  {
    title: 'Soyisim',
    dataIndex: 'last_name',
    key: 'last_name',
    width: 150,
    sorter: (a, b) => a.last_name?.localeCompare(b.last_name),
  },
  {
    title: 'Rol',
    dataIndex: 'role',
    key: 'role',
    searchable: true,
    width: 200,
    sorter: (a, b) => a.role.id - b.role.id,
    render: (_, record) => (
      <div>
        {roles.find((item) => item.id === record.role?.id)?.external_name}
      </div>
    ),
  },
  {
    title: 'Pozisyon',
    dataIndex: 'position',
    key: 'position',
    width: 150,
    searchable: true,
    sorter: (a, b) => (a.position || '')?.localeCompare(b.position || ''),
  },
  {
    title: 'Departman',
    dataIndex: 'department',
    key: 'department',
    width: 150,
    sorter: (a, b) => (a.department || '')?.localeCompare(b.department || ''),
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    width: 200,
    sorter: (a, b) => a.email?.localeCompare(b.email),
  },
  {
    title: 'Telefon',
    dataIndex: 'phone_number',
    key: 'phone_number',
    width: 150,
    sorter: (a, b) => a.phone_number?.localeCompare(b.phone_number),
  },
  {
    title: 'Kayıt Tarihi',
    dataIndex: 'created_at',
    key: 'created_at',
    width: 175,
    sorter: true,
    render: (_, record) => (
      <div>{record.created_at ? formatISOString(record.created_at) : null}</div>
    ),
  },
  {
    title: 'Oluşturan Kullanıcı',
    dataIndex: 'created_by',
    key: 'created_by',
    width: 175,
    sorter: (a, b) => a.created_by?.localeCompare(b.created_by),
  },
  {
    title: 'İşlem',
    dataIndex: 'action',
    key: 'action',
    width: 75,
    render: (_: unknown, record: IUserSettingsDataSource) => (
      <Flex justify="flex-end" gap={14}>
        <Popconfirm
          title={
            <div className={styles.popconfirmTitle}>
              Silme işlemini onaylıyor musunuz?
            </div>
          }
          overlayInnerStyle={{
            width: 150,
            borderColor: '#D6222A',
            borderWidth: 1,
            borderStyle: 'solid',
          }}
          okText="Onayla"
          cancelText="İptal"
          icon={null}
          color="#FAFAFA"
          okButtonProps={{ danger: true, style: { width: '45%' } }}
          cancelButtonProps={{ danger: true, style: { width: '45%' } }}
          onConfirm={() => record.id && handleClickDelete(record.id)}
        >
          <AuthorizedIcon
            action="delete"
            model="user"
            popoverText={actionTypes.DELETE}
            source={TrashSolidBlack}
          />
        </Popconfirm>
        <AuthorizedIcon
          action="change"
          model="user"
          popoverText={actionTypes.CHANGE}
          source={PenToSquareSolidBlack}
          onClick={() => record?.id && handleOpenEditModal(record.id)}
        />
      </Flex>
    ),
  },
];
